import api from '../api-methods'
const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API
const space = {
  postVirtualization: data => {
    return api.post(proxyApi + '/v1/virtualization', data)
  },
  getVirtualization: () => {
    return api.get(proxyApi + '/v1/virtualization')
  },
  // 获取直播id
  getLivePlayId : () => {
    return api.get(proxyApi + '/v1/virtualization/virtual_live')
  },

  // 获取签到状态
  getSignInStatus : (data) => {
    return api.get(proxyApi + `/v1/virtualization/${data}/virtual_sign_in`)
  },

  // 创建签到预约状态
  postSignInStatus : (data) => {
    return api.post(proxyApi + `/v1/virtualization/${data}/virtual_sign_in`)
  },

// 获取直播详情
  getLivePlayDetail : (data) => {
    return api.get(proxyApi + `/v3/lives/${data}`)
  },
  //预约直播
  liveAddAppoint :(live_token) => {
    return api.post(proxyApi + `/v3/lives/${live_token}/appoint`)
  },
  //是否预约过
  isSubscribeLive:(data) => {
    return api.post(proxyApi + `/v3/lives/appoint`,data)
  },
  // 获取简历 list
  getCvList:(data) => {
    return api.get(proxyApi + '/v3/cvs', data)
  },
  // 获取简历 list
  getUserInfo:(cv_account_token) => {
    return api.get(proxyApi + `/v3/cv_accounts/${cv_account_token}`)
  },
  // 获取简历是否公开
  getCvInvisible: (cvAccountToken, params) => {
    return api.get(proxyApi + `/v3/cv_accounts/${ cvAccountToken }/cv_visibility`, params)
  },

  // 获取在线简历
  getOnlineCv: (cvAccountToken) => {
    return api.get(proxyApi + `/v3/cv_accounts/${ cvAccountToken }/online_cv`)
  }

}

export default space
